export default __webpack_public_path__ + "static/media/icon-checkmark-circle-1.9690b632.svg";